import useApi from "@/hooks/useApi";
import { useLivePreview } from "@/hooks/useLivePreview";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
export default function useHomeData() {
  const { GET } = useApi();
  const [pageData, setPageData] = useState(null);

  const { data, isLoading, error } = useQuery({
    queryKey: ["home"],
    queryFn: () => GET("/pages/1?depth=1"),
  });

  const { data: liveData, isLoading: liveIsLoading } = useLivePreview({
    serverURL: process.env.NEXT_PUBLIC_CMS_URL,
    depth: 1,
    initialData: data,
  });

  useEffect(() => {
    if (liveData) {
      setPageData(liveData?.layout[0]);
    }
  }, [liveData]);

  return { pageData, isLoading: isLoading || liveIsLoading, error };
}
